var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brackets__status",class:_vm._f("lowercase")(_vm.status)},[_c('span',[_vm._v("MID #"+_vm._s(_vm.id))])])
}
var staticRenderFns = []

export { render, staticRenderFns }